export default __webpack_public_path__ + "static/media/youtube-media.00df8bad.svg";